import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound';
import { useGetAllAssignmentQuery, useRemoveUserAssignmentMutation } from '../../../../services/EndPointsApis';
import StepperAssignment from './SidebarStepperAssignment/StepperAssignment';
import { label } from 'yet-another-react-lightbox/*';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import DateComp from '../../../../core/common/dateComponent/DateComp';
import AssignmentSidebar from './AssignmentSidebarChanged/AssignmentSidebar';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import { toast } from 'react-toastify';

const Assignments = ({ projectLookups, projectByIdData, projectId, projectRecordNumber, refetch, refetchClientView }: any) => {

    const [togglestepperAssignment, setTogglestepperAssignment] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleShowstepper = () => {
        setTogglestepperAssignment(true);
        setIsEditing(false);
    };
    const handleclosestepper = () => {
        setTogglestepperAssignment(false);
    };

    //remove user 
    const [removeUser, { data: removeUserData, isError: isErrorRemoveUser, error: errorRemoveUser, isSuccess: isSuccessRemoveUser }] = useRemoveUserAssignmentMutation();

    //Permission Hook
    const { view: viewAssing, edit: editAssig, create: createAssig } = usePermission(constantsPermission?.moduleId?.assignments);

    //Get All Assinments
    const { data: AssignmentDetails, isLoading, isSuccess, refetch: refetchAssignments, isError, error } = useGetAllAssignmentQuery({
        ProjectId: projectId
    });

    const [showfilterModal, setShowfilterModal] = useState(false);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [userId, setUserId] = useState<any>(null)
    const handleShowAsssignModal = (userId: any) => {
        setShowAssignModal(true)
        setUserId(userId)
    };
    const handleCloseAsssignModal = () => {
        setShowAssignModal(false)

    }
    const handleClose = () => {
        setShowfilterModal(false)
    };
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const [BusinessUnitValue, setBusinessUnitValue] = useState({ label: '', value: 0 })
    const soldStatus = projectByIdData?.result?.projectStatus === 'Active' || projectByIdData?.result?.projectStatus === 'Marked Dead' || projectByIdData?.result?.projectStatus === 'Marked For Rehash Follow' || projectByIdData?.result?.projectStatus === 'Promoted Lead to SW';
    
    const handleRemoveUser = () => {
        removeUser({ projectId: projectId, UserId: userId })
        setShowAssignModal(false)
    }

    useEffect(() => {
        if (isSuccessRemoveUser) {

            toast.success(removeUserData.message);
            refetchAssignments()
        }
    },
        [isSuccessRemoveUser]);

    useEffect(() => {
        if (isErrorRemoveUser && errorRemoveUser) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in errorRemoveUser && errorRemoveUser.data && typeof errorRemoveUser.data === 'object' && 'message' in errorRemoveUser.data) {
                errorMessage = (errorRemoveUser.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isErrorRemoveUser, errorRemoveUser]);
    return (
        <>
            {/* <StepperAssignment projectRecordNumber={projectRecordNumber}
                refetchAssignments={refetchAssignments} projectLookups={projectLookups}
                BusinessUnitValue={BusinessUnitValue} refetchClientView={refetchClientView}
                projectId={projectId} togglestepperAssignment={togglestepperAssignment} setBusinessUnitValue={setBusinessUnitValue}
                closestepper={handleclosestepper} isEditing={isEditing} refetch={refetch} /> */}
            <AssignmentSidebar projectRecordNumber={projectRecordNumber}
                refetchAssignments={refetchAssignments} projectLookups={projectLookups}
                BusinessUnitValue={BusinessUnitValue} refetchClientView={refetchClientView}
                projectId={projectId} togglestepperAssignment={togglestepperAssignment} setBusinessUnitValue={setBusinessUnitValue}
                closestepper={handleclosestepper} isEditing={isEditing} refetch={refetch} />

            <ModalComponent
                modalTitle='Saving Current Filters'
                isVisible={showfilterModal}
                cancelButton="Cancel"
                onClose={handleClose}
                saveButton='Save'
                className="p-2"
                onSave={handleRemoveUser}

            >
                <>
                    <div className="col-md-12">
                        <label className="col-form-label">
                            Filter Name<span className="text-danger"> *</span>
                        </label>
                        <input type="text" className="form-control" />
                    </div>
                </>

            </ModalComponent>
            <ModalComponent
                modalTitle='Confirmation UnAssign Modal'
                isVisible={showAssignModal}
                cancelButton="No"
                onClose={handleCloseAsssignModal}
                saveButton='Yes'
                className="p-2"
                onSave={handleRemoveUser}

            >
                <>
                    <div className="col-md-12">
                        Are You Sure You Want To UnAssign This User?
                    </div>
                </>

            </ModalComponent>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="card main-card card-css">
                        <div className="card-body">
                            {/* Search */}
                            <div className="col-md-12 col-sm-12 mb-3">
                                {createAssig &&
                                    <div className='d-flex justify-content-end gap-3'>
                                        <div className='d-flex align-items-center gap-2'><p className='mb-0'>Assign:</p>  <Select
                                            styles={customStyles}
                                            className="select select-width"
                                            placeholder='Select'
                                            options={
                                                projectLookups?.result?.Lst_BusinessUnit
                                                    ?.filter((option: any) =>
                                                        projectByIdData?.result?.pdm !== null ? option?.id !== 1 : true
                                                    )
                                                    .map((option: any) => ({
                                                        label: option?.value,
                                                        value: option?.id
                                                    })) || []
                                            }
                                            value={BusinessUnitValue ?
                                                {
                                                    label: BusinessUnitValue?.label || 'Select',
                                                    value: BusinessUnitValue?.value
                                                }
                                                :
                                                null
                                            }
                                            onChange={(selectedOption: any) => setBusinessUnitValue(selectedOption)}
                                        /></div>
                                        <button className="btn btn-primary ps-3 pe-3" onClick={handleShowstepper} disabled={BusinessUnitValue?.label === '' || soldStatus}>Go</button>
                                    </div>
                                }
                            </div>
                            <div className='row height-overflow'>
                                <div className='col-md-12'>
                                    <div className='bg-gray'>
                                        <h6>Name</h6>
                                    </div>
                                    <div className="mt-3">
                                        {AssignmentDetails?.result?.data?.length > 0 ?
                                            <>
                                                {AssignmentDetails?.result?.data?.map((user: any) => (
                                                    <div key={user.userAccountID} className="user-accordion mb-3">
                                                        <Link
                                                            to="#"
                                                            className="task-accordion d-flex gap-2"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#user-${user.userAccountID}`}
                                                        >
                                                            <span className="dropdown-toggle "></span>
                                                            <div className='d-flex align-items-center gap-3'>
                                                                <b>
                                                                    {user.userName} - {user.roleName}
                                                                </b>
                                                                <button className='btn light' onClick={() => handleShowAsssignModal(user.userAccountID)}>
                                                                    <i className="fas fa-user-times"></i>
                                                                </button>
                                                            </div>
                                                        </Link>
                                                        <div
                                                            className="tasks-activity tasks w-100 collapse"
                                                            id={`user-${user.userAccountID}`}
                                                        >
                                                            <div className="table-responsive mt-2">
                                                                <table className="table datanew dataTable no-footer table-hover">
                                                                    <thead>
                                                                        <tr>
                                                                            {/* <th>
                                                                        <input
                                                                            type="checkbox"
                                                                            className='form-check-input cursor-pointer'
                                                                            checked={isTableHeadChecked}
                                                                            onChange={handleTableHeadChange}
                                                                        />
                                                                    </th> */}
                                                                            {/* <th>ID</th> */}
                                                                            <th style={{ width: '200px' }}>ROLE</th>
                                                                            <th style={{ width: '200px' }}>SOURCE</th>
                                                                            <th style={{ width: '200px' }}>ASSIGNED BY</th>
                                                                            <th style={{ width: '200px' }}>DT ASSIGNED</th>
                                                                            <th style={{ width: '200px' }}>DT UNASSIGNED</th>
                                                                            <th style={{ width: '200px' }}>PT PERSON</th>
                                                                            <th style={{ width: '200px' }}>REASON UNASSIGNE</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            className=''>
                                                                            <td>{user?.roleName}</td>
                                                                            <td>{user?.source}</td>
                                                                            <td>{user?.roleName}</td>
                                                                            <td><DateComp formattedDate={user.assignedDate} /></td>
                                                                            <td>{user?.roleName}</td>
                                                                            <td>{user?.roleName}</td>
                                                                            <td>{user?.roleName}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                            :
                                            <tr className='d-flex justify-content-center'>
                                                <td>
                                                    <NoRecordFound />
                                                </td>
                                            </tr>
                                        }
                                        {/* {isLoading &&
                                            <TableLoading />
                                        } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default Assignments